import React, { useState, useMemo } from "react";
import LeavesReviewUsersLoader from "./Loaders/LeavesReviewUsersLoader";
import LeavesReviewLeavesLoader from "./Loaders/LeavesReviewLeavesLoader";
import LeavesReview from "./LeavesReview";
import LeavesReviewSearch from "./LeavesReviewSearch";

const LeavesReviewContainer: React.FC = () => {
  const [selectedUser, setSelectedUser] = useState<{
    id: number;
    full_name: string;
    rut?: string;
  } | null>(null);
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [queryKey, setQueryKey] = useState(0);
  const [search, setSearch] = useState("");

  const leavesQuery = useMemo(
    () => ({
      userId: selectedUser?.id ? String(selectedUser.id) : null,
      date: selectedDate,
    }),
    [selectedUser, selectedDate]
  );

  const triggerDateSearch = () => setQueryKey((k) => k + 1);
  const handleSearchReset = () => {
    setSelectedUser(null);
    setSearch("");
  };

  return (
    <LeavesReviewUsersLoader>
      {({ users }) => (
        <>
          <LeavesReviewSearch
            users={users}
            search={search}
            setSearch={setSearch}
            selectedUser={selectedUser}
            setSelectedUser={setSelectedUser}
            handleSearchReset={handleSearchReset}
          />
          {selectedUser ? (
            <LeavesReviewLeavesLoader
              key={`${selectedUser?.id || "no-user"}-${queryKey}`}
              defaultQuery={leavesQuery}
              fetchImmediately
            >
              {(data) => (
                <LeavesReview
                  selectedUser={selectedUser}
                  selectedDate={selectedDate}
                  setSelectedDate={setSelectedDate}
                  triggerDateSearch={triggerDateSearch}
                  leavesData={data}
                />
              )}
            </LeavesReviewLeavesLoader>
          ) : (
            <LeavesReview
              selectedUser={null}
              selectedDate={selectedDate}
              setSelectedDate={setSelectedDate}
              triggerDateSearch={triggerDateSearch}
              leavesData={undefined}
            />
          )}
        </>
      )}
    </LeavesReviewUsersLoader>
  );
};

export default LeavesReviewContainer;
export { LeavesReviewContainer as LeavesReview };
